// extracted by mini-css-extract-plugin
export default {"bottom":"_1Q-d1RX0kTD2vlLZtManN5","buildingButton":"_381fv4gkaSQ2wf2xa_Dl-U"};